import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'

import { actionerList, companyList } from './data'

import styles from './style.module.scss'

const ViewActionersList = ({ hideExperience }: { hideExperience?: boolean }) => (
	<ul className={styles.actioners}>
		{actionerList.map(({ photo, name, post, experience }, index) => (
			<li key={index} className={styles.actioner}>
				<Image name={photo} className={styles.photo} lazy alt={name} />
				<p className={styles.name}>{name}</p>
				<p className={styles.post}>{post}</p>
				{experience && !hideExperience && (
					<p className={styles.experience}>
						Опыт: <br />
						{experience}
					</p>
				)}
			</li>
		))}
	</ul>
)

export const ViewOnlyActionersList = () => (
	<Section className={styles.wrapper}>
		<h2 className={styles.title}>Акционеры</h2>
		<ViewActionersList hideExperience />
	</Section>
)

export const View = () => {
	return (
		<Section className={styles.wrapper}>
			<div className={styles.header}>
				<div>
					<h3 className={styles.title}>Акционеры группы компаний — часть команды</h3>
				</div>
				<div>
					<h4 className={styles.subtitle}>
						Они активно участвуют в&nbsp;развитии компании: не&nbsp;только инвестируют,
						но&nbsp;и&nbsp;делятся своей экспертизой в&nbsp;разных областях.
					</h4>
				</div>
			</div>
			<ViewActionersList />
			<div className={styles.footer}>
				<p className={styles.footerText}>
					На сегодняшний день акционеры холдинга Credit.Club занимают топ-позиции ведущих компаний,
					в том числе международных, таких как:
				</p>
				<div className={styles.companyList}>
					{companyList.map((company, index) => (
						<Image lazy name={company} key={index} />
					))}
				</div>
			</div>
		</Section>
	)
}
